import { z } from 'zod';

import { moneySchema } from './common.js';

export const dashboardMetricsSchema = z.object({
  upcomingStays: z.number().int().nonnegative(),
  activeReservations: z.number().int().nonnegative(),
  outstandingCents: moneySchema,
  operationalAlerts: z.number().int().nonnegative(),
});

export type DashboardMetrics = z.infer<typeof dashboardMetricsSchema>;
